<template>
  <div class="vs-con-input">
    <date-range-picker
      v-model="model"
      :name="name"
      :options="options"
      :className="'vs-inputx vs-input--input normal'"
      @input="apply()"
    ></date-range-picker>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "daterange-input",
  props: ["value", "name"],
  data: () => {
    return {
      model: null,
      input: null,
      options: {
        autoApply: true,
        autoUpdateInput: false,
        maxSpan: {
          days: 180
        },
        ranges: {
          Hoje: [moment(), moment()],
          Ontem: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Últimos 7 dias": [moment().subtract(6, "days"), moment()],
          "Últimos 30 dias": [moment().subtract(29, "days"), moment()],
          "Este mês": [moment().startOf("month"), moment().endOf("month")],
          "Mês passado": [
            moment()
              .subtract(1, "month")
              .startOf("month"),
            moment()
              .subtract(1, "month")
              .endOf("month")
          ]
        },
        locale: {
          format: "DD/MM/YYYY",
          separator: " - ",
          applyLabel: "Confirmar",
          cancelLabel: "Cancelar",
          fromLabel: "De",
          toLabel: "Até",
          customRangeLabel: "Personalizar",
          weekLabel: "S",
          daysOfWeek: ["D", "S", "T", "Q", "Q", "S", "S"],
          monthNames: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro"
          ],
          firstDay: 1
        }
      }
    };
  },
  created() {
    this.model = this.value;
  },
  mounted() {
    this.input = this.$el.querySelector("input");
    if (this.name) {
      this.input.name = this.name;
    }
  },
  watch: {
    value(value) {
      this.model = value;
    }
  },
  methods: {
    apply() {
      if (typeof this.model == "undefined" || this.model == null) {
        this.input.value = "";
        return;
      }

      this.$nextTick(() => {
        this.input.value = this.model[0] + " - " + this.model[1];

        this.$emit("input", this.model);
      });
    }
  }
};
</script>
